import React from 'react'
import PropTypes from 'prop-types'

const PasswordRequirements = ({ passwordTouched, password, passwordToConfirm }) => {
  const AlertIcon = <span className='fas fa-exclamation-circle text-danger' aria-label='failed' />
  const CheckIcon = <span className='fas fa-check-circle text-success' aria-label='passed' />

  return (
    <div id='password_confirmation_error' aria-live='polite' role='region'>
      {
        passwordTouched || password.length > 0
          ? (
            <div>
              {password.length >= 6
                ? <small
                  id='passwordLength'
                  className='d-block d-md-inline-block mt-1 text-success px-2'
                  aria-label='Use 6 or more characters requirement fulfilled'
                >{CheckIcon} Use 6 or more characters</small>
                : <small
                  id='passwordLength'
                  className='d-block d-md-inline-block mt-1 text-danger px-2'
                  aria-label='Use 6 or more characters'>{AlertIcon} Use 6 or more characters</small>
              }

              {/[A-Z]/.test(password)
                ? <small
                  id='passwordUppercase'
                  className='d-block d-md-inline-block mt-1 text-success px-2'
                  aria-label='At least 1 uppercase letter requirement fulfilled'
                >{CheckIcon} At least 1 uppercase letter</small>
                : <small
                  id='passwordUppercase'
                  className='d-block d-md-inline-block mt-1 text-danger px-2'
                  aria-label='At least 1 uppercase letter'
                >{AlertIcon} At least 1 uppercase letter</small>
              }

              {/\d/.test(password)
                ? <small
                  id='passwordNumber'
                  className='d-block d-md-inline-block mt-1 text-success px-2'
                  aria-label='At least 1 number requirement fulfilled'
                >{CheckIcon} At least 1 number</small>
                : <small
                  id='passwordNumber'
                  className='d-block d-md-inline-block mt-1 text-danger px-2'
                  aria-label='At least 1 number'
                >{AlertIcon} At least 1 number</small>
              }

              {password.length > 0 && (passwordToConfirm === password)
                ? <small
                  id='passwordMatch'
                  className='d-block d-md-inline-block mt-1 mb-2 text-success px-2'
                  aria-label='Both passwords must match requirement fulfilled'
                >{CheckIcon} Both passwords must match</small>
                : <small
                  id='passwordMatch'
                  className='d-block d-md-inline-block mt-1 mb-2 text-danger px-2'
                  aria-label='Both passwords must match'
                >{AlertIcon} Both passwords must match</small>
              }
            </div>
          ) : (
            <div>
              <small
                id='passwordLength'
                className='d-block d-md-inline-block mt-1 px-2'
                aria-label='Use 6 or more characters'>
                Use 6 or more characters
              </small>
              <small
                id='passwordUppercase'
                className='d-block d-md-inline-block mt-1 px-2'
                aria-label='At least 1 uppercase letter'>
                At least 1 uppercase letter
              </small>
              <small
                id='passwordNumber'
                className='d-block d-md-inline-block mt-1 px-2'
                aria-label='At least 1 number'>
                At least 1 number
              </small>
              <small
                id='passwordMatch'
                className='d-block d-md-inline-block mt-1 mb-2 px-2'
                aria-label='Both passwords must match'>
                Both passwords must match
              </small>
            </div>
          )
      }
    </div>
  )
}

PasswordRequirements.propTypes = {
  passwordTouched: PropTypes.bool,
  password: PropTypes.string,
  passwordToConfirm: PropTypes.string
}

export default PasswordRequirements
